// Contact.js
import React from "react";
import ContactForm from "./ContactForm";
import ContactInfo from "./ContactInfo";

const Contact = () => {
  return (
    <section id="contact" className="contact section-bg">
      <div className="container">
        <div className="section-title">
          <h2>Contact</h2>
          <p>Get in touch with me</p>
        </div>

        <div className="row">
          <div className="col-lg-6">
            <ContactForm />
          </div>
          <div className="col-lg-6">
            <ContactInfo />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
